import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import { Helmet } from "react-helmet";
import Spinner from "../../Spinner/spinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { localeEs } from "../../locale/ag-grid-es";
import ModalAsignacion from "../Assignment/AssignModal";
import BreadCrum from "../../breadCrum/breadCrum";
import withTokenCheck from "../../withTokenCheck";

const AppReintegros = ({ token }) => {
    const [infoHospitalizados, setInfoHospitalizados] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [, setSelectedHabitaciones] = useState([]);
    const gridApi = useRef(null);
    const etiquetas = [
        "Inicio Lossman",
        "Cambios De Evento",
        "Reintegro Pacientes En Hospitalización",
    ];
    const handleModalToggle = () => setModalOpen(!modalOpen);

    useEffect(() => {
        if (token) {
            axios
                .get("/asignacion/reporte/hospitalizados", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    console.log(response.data);
                    setInfoHospitalizados(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [token]);

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    const columnDefs = [
        {
            field: "id",
            headerName: "Excepeción hospitalización",
            cellRenderer: (params) => (
                <Button
                    color="secondary"
                    onClick={() => handleEditClick(params.data)}
                >
                    Reintegrar al servicio
                </Button>
            ),
        },
        {
            field: "NumeroCaso",
            headerName: "Numero de Caso",
        },
        {
            field: "Paciente.id",
            headerName: "Paciente",
            cellRenderer: (params) => {
                const Nombre = params.data.paciente
                    ? params.data.paciente.Nombre1 +
                      " " +
                      (params.data.paciente.Nombre2
                          ? params.data.paciente.Nombre2
                          : "") +
                      " " +
                      params.data.paciente.Apellido1 +
                      " " +
                      (params.data.Apellido2 ? params.data.Apellido2 : "")
                    : " ";
                return Nombre;
            },
        },
        {
            field: "updated_by.name",
            headerName: "Usuario actualización",
        },
        {
            field: "updated_at",
            headerName: "Fecha Actualización",
        },
    ];

    const handleEditClick = (element) => {
        console.log(element);
        setModalContent(element);
        handleModalToggle();
    };

    const handleExportCSV = () => {
        gridApi.current.exportDataAsCsv();
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const handleUpdateTable = () => {
        setLoading(true);
        if (token) {
            axios
                .get("/asignacion/reporte/hospitalizados", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setInfoHospitalizados(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return (
        <>
            <Helmet>
                <title>Reintegros</title>
            </Helmet>
            <div style={{ position: "relative" }}>
                {loading && <Spinner />}
                <div>
                    <BreadCrum etiquetas={etiquetas} />
                </div>
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                    <div className="container-fluid mt-5">
                        <Button color="success" onClick={handleExportCSV}>
                            Exportar CSV (Excel)
                        </Button>
                        <div
                            className="mt-3"
                            style={{ height: "500px", width: "100%" }}
                        >
                            <div
                                className="ag-theme-alpine"
                                style={{ height: "100%", width: "100%" }}
                            >
                                <AgGridReact
                                    rowData={infoHospitalizados}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ModalAsignacion
                isOpen={modalOpen}
                toggle={handleModalToggle}
                title={modalContent.title}
                content={modalContent.content ? modalContent.content : ""}
                footer={modalContent.footer}
                FormId={modalContent.id ? modalContent.id : ""}
                token={token}
                handleUpdateTable={handleUpdateTable}
                pacienteId={
                    modalContent.paciente ? modalContent.paciente.id : ""
                }
                paciente={modalContent.paciente ? modalContent.paciente : ""}
                companionsData={[]}
                companion={[]}
                setSelectedHabitaciones={setSelectedHabitaciones}
            />
        </>
    );
};

export default withTokenCheck(AppReintegros);
